import { statisticsService } from 'src/services'

export function loadStatistics({ dispatch, commit, state }) {
  commit('startLoading');
  statisticsService.getMongoStatistics(function(data) {
    if(data.status === 401) dispatch('authentication/expired', data, {root:true});
    else commit('receivedData', data['hydra:member'])
  })
}
